import request from "@/utils/request";

// 获取 APP 版本配置列表
export function getAppVersionConfigList(data) {
  return request({
    url: "/admin/appVersionConfig/list",
    method: "post",
    data,
  });
}

// 新增 APP 版本配置
export function addAppVersionConfig(data) {
  return request({
    url: "/admin/appVersionConfig/create",
    method: "post",
    data,
  });
}

// 更新 APP 版本配置
export function updateAppVersionConfig(data) {
  return request({
    url: "/admin/appVersionConfig/update",
    method: "post",
    data,
  });
}

// 删除 APP 版本配置
export function deleteAppVersionConfig(data) {
  return request({
    url: "/admin/appVersionConfig/delete",
    method: "post",
    data,
  });
}

// 获取 APP 版本配置详情
export function getAppVersionConfigDetails(data) {
  return request({
    url: "/admin/appVersionConfig/details",
    method: "post",
    data,
  });
}
